import React from 'react'

const ReportCallDetailItem = (props) => {
    const {item} = props

    return (
        <tr className="CustomersItem">
            <td>{item.tenantName || '-'}</td>
            <td>{item.startTime || '-'}</td>
            <td>{item.caller || '-'}</td>
            <td>{item.called || '-'}</td>
            <td>{item.agentId || '-'}</td>
            <td>{item.duration || '-'}</td>
            <td>{item.transId || '-'}</td>
        </tr>
    )
}

export default ReportCallDetailItem
